import { TransitionSnackbarVariant, transitionSnackbarState } from "@/atoms/snackbarState"
import { Slide } from "@mui/material"
import { TransitionProps } from "@mui/material/transitions"
import { useSetAtom } from "jotai"
import React, { useCallback } from "react"

type TransitionOpenSnackbarParams = {
  message: string
  Transition?: React.ComponentType<
    TransitionProps & {
      children: React.ReactElement<any, any>
    }
  >
  variant?: TransitionSnackbarVariant
}

const useTransitionSnackbar = () => {
  const setState = useSetAtom(transitionSnackbarState)

  const handleOpenSnackbar = useCallback(
    ({ message, Transition = Slide, variant = "success" }: TransitionOpenSnackbarParams) => {
      setState((prev) => ({
        ...prev,
        open: true,
        Transition: Transition || prev.Transition,
        message,
        variant: variant || prev.variant,
      }))
    },
    [setState],
  )

  const handleCloseSnackbar = useCallback(() => {
    setState((prev) => ({
      ...prev,
      open: false,
    }))
  }, [setState])

  return {
    handleOpenSnackbar,
    handleCloseSnackbar,
  }
}

export default useTransitionSnackbar
